import initReactApp from 'dpl/util/initReactApp';
import AdoptionApplicationEntryContainer from 'dpl/adoption_application/containers/ApplicationEntryContainer';
import AdoptionApplicationOverlay from 'dpl/adoption_application/components/Overlay';

initReactApp({
  AdoptionApplicationEntryContainer,
  AdoptionApplicationOverlay
});
